/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Default_NameInputs */



/**
* | output |
* | --- |
* | "Translation Group" |
*
* @param {Translation_Merge_Default_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_default_name = /** @type {((inputs?: Translation_Merge_Default_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Default_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа переводов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳グループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Tradução")
	return /** @type {LocalizedString} */ ("Translation Group")
});